import TransportationAttachment from './TransportationAttachment';

export default TransportationAttachment;
